import React from 'react';
import { Route, Redirect } from 'react-router-dom';

import SITE_PATHS from '../config/sitePaths';

export default function privateRoute({
  component: Component, isAllowedAccess, ...rest
}) {
  // Render the desired component if authenticated, or redirect user back to '/' if not authorized
  const onRender = (props) => {
    const { location } = props;
    if (isAllowedAccess) {
      // eslint-disable-next-line react/jsx-props-no-spreading
      return <Component {...props} {...rest} />;
    }
    return <Redirect to={{ pathname: SITE_PATHS.ROOT, state: { from: location } }} />;
  };
  // eslint-disable-next-line react/jsx-props-no-spreading
  return <Route {...rest} render={onRender} />;
}
